import React from 'react'
import "./AboutUsPage.css";
import AboutUsSection from './AboutUsSection';
import OurMissionSection from './OurMissionSection';

function AboutUsPage() {
  return (
    <div>
       <div className="page-container">
       <AboutUsSection/>
       <OurMissionSection/>
      </div>
    </div>
  )
}

export default AboutUsPage
